import { useInvalidate } from '@refinedev/core';

import { useSnackbar } from '@rrexpress/core';

import { useModal } from '@/hooks/useModal';
import useUser from '@/modules/user/application/user';

import UserManagementForm from './form';

const UserManagementCreate = () => {
  const { createUser, loadingCreate } = useUser();
  const { show } = useSnackbar();
  const invalidate = useInvalidate();
  const { close } = useModal();

  async function handleOnSubmit(val: any) {
    const newVal = { ...val };

    newVal.user_name = newVal.email;
    newVal.is_superadmin_user = false;
    newVal.is_owner = false;
    newVal.is_send_confirmation_link = true;

    try {
      await createUser(newVal);
      invalidate({ resource: 'cp-users', invalidates: ['list'] });
      close();
      show('Berhasil mengundang user', 'success');
    } catch (error) {
      show('Gagal mengundang user', 'error');
    }
  }

  return (
    <div className="p-4">
      <UserManagementForm
        loading={loadingCreate}
        initialValue={{}}
        onFinish={handleOnSubmit}
        type="create"
      />
    </div>
  );
};

export default UserManagementCreate;
